<template>
  <div>
    <kisiadresara v-model="adresDialogData" v-bind:value="Adres"></kisiadresara>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Çoklu Kişi Ekle</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark flat @click.native="agree">{{ $t('save_button') }}</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card>
        <v-card-text class="pa-4">
          <v-layout wrap>
            <v-flex xs12 sm12 md12>
              <v-btn @click="kisiAra()" round color="error">
                <v-icon> person_search </v-icon> {{ $t('Search-Person') }}
              </v-btn>
              <v-btn @click="addDialogOpen()" round color="error">
                <v-icon> person_add </v-icon> Kişi Ekle
              </v-btn>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-data-table
                :headers="headersKisi"
                :rows-per-page-items="[50, 100]"
                :items="value"
                item-key="id"
              >
                <template slot="items" slot-scope="props">
                  <tr item>
                    <td class="text-xs-left">{{ props.item.adSoyad }}</td>
                    <td class="text-xs-left">{{ props.item.gsm }}</td>
                    <td class="text-xs-left">{{ props.item.tcKimlikNo }}</td>
                    <td class="text-xs-left">
                      {{ props.item.dogumTarihi | dateformat }}
                    </td>
                    <td class="text-xs-left">{{ props.item.PasaportNo }}</td>
                    <td class="text-xs-left">{{ props.item.VerildigiYer }}</td>
                    <td class="text-xs-left">
                      {{ getPasaportTip(props.item.PasaportTip) }}
                    </td>
                    <td class="text-xs-left">
                      {{ props.item.VerilisTarihi | dateformat }}
                    </td>
                    <td class="text-xs-left">
                      {{ props.item.BitisTarihi | dateformat }}
                    </td>

                    <td class="text-xs-center">
                      <v-icon color="green" @click="editUser(props.item,props.index)">
                        edit
                      </v-icon>
                      <v-icon color="red" @click="deleteUser(props.item)">
                        delete
                      </v-icon>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Kisi ekle / duzenle dialog -->

    <v-dialog persistent max-width="700px" v-model="dialogKisi">
      <v-card>
        <v-card-title style="background-color: #01579b">
          <span v-if="!guncelle" class="headline white--text">Kişi Ekle</span>
          <span v-if="guncelle" class="headline white--text"
            >Kişi Güncelle</span
          >
        </v-card-title>
        <v-card-text class="pa-4">
          <v-layout wrap>
            <v-flex xs12 sm12 md12>
              <v-form ref="kisibilgi">
                <v-flex xs12 sm12 md12>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md6>
                      <v-text-field
                        :label="$t('Name_label')"
                        v-model="kisiDialogParams.firstName"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <v-text-field
                        :label="$t('Surname_label')"
                        v-model="kisiDialogParams.lastName"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md6>
                      <v-text-field
                        label="GSM"
                        v-model="kisiDialogParams.gsm"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <v-text-field
                        mask="###########"
                        label="TC"
                        v-model="kisiDialogParams.tcKimlikNo"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md6>
                      <tarihim
                        :etiket="$t('Date-of-Birth')"
                        :detaygizle="false"
                        v-bind:defaultvalue="'no'"
                        v-model="kisiDialogParams.dogumTarihi"
                      ></tarihim>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <v-text-field
                        :label="$t('Passport-No')"
                        v-model="kisiDialogParams.PasaportNo"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm12 md12>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md6>
                      <v-text-field
                        :label="$t('Place-Issue')"
                        v-model="kisiDialogParams.VerildigiYer"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <v-select
                        hide-details
                        :items="itemsPasaportTip"
                        item-text="text"
                        item-value="value"
                        label="Pasaport Tip"
                        v-model="kisiDialogParams.PasaportTip"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm12 md12>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md6>
                      <tarihim
                        :etiket="$t('Date-Issue')"
                        :detaygizle="false"
                        v-bind:defaultvalue="'no'"
                        v-model="kisiDialogParams.VerilisTarihi"
                      ></tarihim>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <tarihim
                        :etiket="$t('Finishing-Date')"
                        :detaygizle="false"
                        v-bind:defaultvalue="'no'"
                        v-model="kisiDialogParams.BitisTarihi"
                      ></tarihim>
                    </v-flex>
                  </v-layout>
                </v-flex>
                
                
              </v-form>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn
            v-if="!guncelle"
            color="primary darken-1"
            text
            @click.native="addUser"
            >{{ $t('save_button') }}</v-btn
          >
          <v-btn
            v-if="guncelle"
            color="primary darken-1"
            text
            @click.native="updateUser"
            >{{ $t('Update') }}</v-btn
          >
          <v-btn color="grey" text @click.native="dialogKisi = false">{{
            $t("cancel_button")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import vize from "@/components/app/coper/vize/vize";
import kisiadresara from "@/components/app/coper/component/kisiadresara.vue";
import helpers from "@/components/app/customcomp/helpers.js";
import tarihim from "@/components/app/customcomp/tarihim.vue";

export default {
  props: {
    value: {
      type: Array,
    },
  },
  data() {
    return {
      guncelle: false,
      kisiDialogParams: {
        id: 0,
        kod: 0,
        profilId: 0,
        kisiTip: 0,
        adSoyad: null,
        telefon1: null,
        gsm: null,
        eMail: null,
        tcKimlikNo: null,
        uyeNo: null,
        adres: null,
        dogumTarihi: null,
        cinsiyet: null,
        kisiSira: -1,
        kisiTableRef: 0,
        yas: 0,
        firstName: null,
        lastName: null,
        disID: null,
        PasaportTip: 0,
        PasaportNo: null,
        VerildigiYer: null,
        VerilisTarihi: null,
        BitisTarihi: null,
      },
      itemsPasaportTip: [
        {
          text: "Normal",
          value: 0,
        },
        {
          text: this.$t('Green'),
          value: 1,
        },
        {
          text: this.$t('Diplomatic'),
          value: 2,
        },
        {
          text: this.$t('Other'),
          value: 3,
        },
      ],
      dialogKisi: false,
      itemsKisi: [],
      headersKisi: [
        {
          text: this.$t('Name_Surname_label'),
        },
        {
          text: "GSM",
        },
        {
          text: "TC",
        },
        {
          text: this.$t('Date-of-Birth'),
        },
        {
          text: this.$t('Passport-No'),
        },
        {
          text: this.$t('Place-Issue'),
        },
        {
          text: "Pasaport Tip",
        },
        {
          text: this.$t('Date-Issue'),
        },
        {
          text: this.$t('Finishing-Date'),
        },
        {
          text: this.$t('Process'),
        },
      ],
      dialog: false,
      Adres: vize.Adres(),
      adresDialogData: {
        dialogShow: false,
        adres: vize.Adres(),
      },
      updateUserIndex:0
    };
  },
  methods: {
    updateUser() {
      this.kisiDialogParams.adSoyad =
        this.kisiDialogParams.firstName + " " + this.kisiDialogParams.lastName;
         this.value.splice(this.updateUserIndex, 1);
        this.value.push(this.kisiDialogParams);

      this.dialogKisi = false;
    },
    addDialogOpen() {
      var userCleanData = {
        id: 0,
        kod: 0,
        profilId: 0,
        kisiTip: 0,
        adSoyad: null,
        telefon1: null,
        gsm: null,
        eMail: null,
        tcKimlikNo: null,
        uyeNo: null,
        adres: null,
        dogumTarihi: null,
        cinsiyet: null,
        kisiSira: -1,
        kisiTableRef: 0,
        yas: 0,
        firstName: null,
        lastName: null,
        disID: null,
        PasaportTip: 0,
        PasaportNo: null,
        VerildigiYer: null,
        VerilisTarihi: null,
        BitisTarihi: null,
      };
      this.kisiDialogParams = userCleanData;
      this.guncelle = false;
      this.dialogKisi = true;
    },
    editUser(val,userIndex) {
      this.guncelle = true;
      const shallowClone = { ...val };
      this.updateUserIndex = userIndex;
      this.kisiDialogParams = shallowClone;
      this.dialogKisi = true;
    },
    getPasaportTip(val) {
      const result = this.itemsPasaportTip.find(({ value }) => value === val);
      return result.text;
    },
    addUser() {
      this.kisiDialogParams.adSoyad =
        this.kisiDialogParams.firstName + " " + this.kisiDialogParams.lastName;
      this.value.push(this.kisiDialogParams);
      this.dialogKisi = false;
    },
    deleteUser(val) {
      var deleteIndex = this.value.indexOf(val);
      this.value.splice(deleteIndex, 1);
    },
    kisiAra() {
      this.adresDialogData.dialogShow = true;
    },
    open() {
      this.dialog = true;
    },
    agree() {
      this.$emit("vizeSave");
    },
    cancel() {
      this.dialog = false;
    },
  },
  watch: {
    "adresDialogData.adres": function (val) {
      var editValue = {
        PasaportTip: 0,
        PasaportNo: null,
        VerildigiYer: null,
        VerilisTarihi: null,
        BitisTarihi: null,
      };
      Object.assign(val, editValue);

      this.value.push(val);
    },
  },
  filters: {
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
    priceFormat: function (price) {
      return Number.parseFloat(price).toFixed(2);
    },
    gettime: function (t) {
      return helpers.getTime(t);
    },
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    timeformat: function (c) {
      return helpers.timeformat(c);
    },
  },
  components: {
    kisiadresara,
    tarihim,
  },
};
</script>

<style>
</style>